import { OpenAPI, SupplierService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT
export async function getSupplierDetails(
  supplierId: number,
) {
  let data = SupplierService.getSupplierDetailsSuppliersIdDetailsGet(
    supplierId,
  )

  return data
}
